const browse = () => import('@/views/browse/index.vue');
const statistics = () => import('@/views/statistics/index.vue');
const search = () => import('@/views/search/index.vue');
const index = () => import('@/views/index.vue');

const project = () => import('@/views/project/project.vue');
const subproject = () => import('@/views/project/subproject.vue');
const supproject = () => import('@/views/project/supproject.vue');
const profilelist = () => import('@/views/project/projectFileList.vue');
const contactUs = () => import('@/views/contactus/index.vue');
const clinicalInfo = () => import('@/views/clinicalinfo/index.vue');
const clinicalDetail = () => import('@/views/clinicalinfo/detail.vue');
const message = () => import('@/views/admin/message.vue');
const ProjectStatistics = () => import('@/views/admin/statistics/ProjectStatistics.vue');
const statisticsall = () => import('@/views/admin/statistics/statisticsall.vue');
const sap = () => import('@/views/admin/statistics/sap.vue');
const sp = () => import('@/views/admin/statistics/sp.vue');
const sapf = () => import('@/views/admin/statistics/sapf.vue');
const spf = () => import('@/views/admin/statistics/spf.vue');
const visits = () => import('@/views/admin/statistics/visits.vue');
const hits = () => import('@/views/admin/statistics/hits.vue');
const sdfbd = () => import('@/views/admin/statistics/sdfbd.vue');
const dbp = () => import('@/views/admin/statistics/dbp.vue');
const pbj = () => import('@/views/admin/statistics/pbj.vue');
const pbc = () => import('@/views/admin/statistics/pbc.vue');
const ppbc = () => import('@/views/admin/statistics/ppbc.vue');
const pbi = () => import('@/views/admin/statistics/pbi.vue');
const ppbi = () => import('@/views/admin/statistics/ppbi.vue');
const pbjf = () => import('@/views/admin/statistics/pbjf.vue');
const pwnl = () => import('@/views/admin/statistics/pwnl.vue');
const userinformation = () => import('@/views/admin/userinformation.vue');
const changelog = () => import('@/views/admin/changelog.vue');
const todolist = () => import('@/views/admin/todolist.vue');
export const routerGroup = [
  {
    path: '/',
    component: index,
    name: 'index',
    meta: {
      title: 'Home',
    },
  },
  {
    path: '/browse',
    component: browse,
    name: 'browse',
    meta: {
      title: 'Browse',
    },
  },
  {
    path: '/search',
    component: search,
    name: 'search',
    meta: {
      title: 'Search',
    },
  },
  {
    path: '/statistics',
    component: statistics,
    name: 'statistics',
    meta: {
      title: 'statistics',
    },
  },
  {
    path: '/project',
    component: project,
    name: 'project',
    meta: {
      title: 'project',
    },
  },
  {
    path: '/subproject',
    component: subproject,
    name: 'subproject',
    meta: {
      title: 'subproject',
    },
  },
  {
    path: '/supproject',
    component: supproject,
    name: 'supproject',
    meta: {
      title: 'supproject',
    },
  },
  {
    path: '/profilelist',
    component: profilelist,
    name: 'profilelist',
    meta: {
      title: 'profilelist',
    },
  },
  {
    path: '/contactus',
    component: contactUs,
    name: 'contactus',
    meta: {
      title: 'contactus',
    },
  },
  {
    path: '/clinicalinfo',
    component: clinicalInfo,
    name: 'clinicalinfo',
    meta: {
      title: 'clinicalinfo',
    },
  },
  {
    path: '/clinicaldetail',
    component: clinicalDetail,
    name: 'clinicaldetail',
    meta: {
      title: 'clinicaldetail',
    },
  },
  {
    path: '/message',
    component: message,
    name: 'message',
    meta: {
      title: 'message',
    },
  },
  {
    path: '/admin/statistics/ProjectStatistics',
    component: ProjectStatistics,
    name: 'ProjectStatistics',
    meta: {
      title: 'ProjectStatistics',
    },
  },
  {
    path: '/admin/statistics/statisticsall',
    component: statisticsall,
    name: 'statisticsall',
    meta: {
      title: 'StatisticsAll',
    },
  },
  {
    path: '/userinformation',
    component: userinformation,
    name: 'userinformation',
    meta: {
      title: 'User Information',
    },
  },
  {
    path: '/admin/statistics/sap',
    component: sap,
    name: 'sap',
    meta: {
      title: 'SAP',
    },
  },
  {
    path: '/admin/statistics/sp',
    component: sp,
    name: 'sp',
    meta: {
      title: 'SP',
    },
  },
  {
    path: '/admin/statistics/sapf',
    component: sapf,
    name: 'sapf',
    meta: {
      title: 'SAPF',
    },
  },
  {
    path: '/admin/statistics/spf',
    component: spf,
    name: 'spf',
    meta: {
      title: 'SPF',
    },
  },
  {
    path: '/admin/statistics/visits',
    component: visits,
    name: 'visits',
    meta: {
      title: 'VISITS',
    },
  },
  {
    path: '/admin/statistics/hits',
    component: hits,
    name: 'hits',
    meta: {
      title: 'HITS',
    },
  },
  {
    path: '/admin/statistics/sdfbd',
    component: sdfbd,
    name: 'sdfbd',
    meta: {
      title: 'SDFBD',
    },
  },
  {
    path: '/admin/statistics/dbp',
    component: dbp,
    name: 'dbp',
    meta: {
      title: 'DBP',
    },
  },
  {
    path: '/admin/statistics/pbj',
    component: pbj,
    name: 'pbj',
    meta: {
      title: 'PBJ',
    },
  },
  {
    path: '/admin/statistics/pbc',
    component: pbc,
    name: 'pbc',
    meta: {
      title: 'PBC',
    },
  },
  {
    path: '/admin/statistics/ppbc',
    component: ppbc,
    name: 'ppbc',
    meta: {
      title: 'PPBC',
    },
  },
  {
    path: '/admin/statistics/pbi',
    component: pbi,
    name: 'pbi',
    meta: {
      title: 'PBI',
    },
  },
  {
    path: '/admin/statistics/ppbi',
    component: ppbi,
    name: 'ppbi',
    meta: {
      title: 'PPBI',
    },
  },
  {
    path: '/admin/statistics/pbjf',
    component: pbjf,
    name: 'pbjf',
    meta: {
      title: 'PBJF',
    },
  },
  {
    path: '/admin/statistics/pwnl',
    component: pwnl,
    name: 'pwnl',
    meta: {
      title: 'PWNL',
    },
  },
  {
    path: '/admin/changelog',
    component: changelog,
    name: 'changelog',
    meta: {
      title: 'changelog',
    },
  },
  {
    path: '/admin/todolist',
    component: todolist,
    name: 'todolist',
    meta: {
      title: 'todolist',
    },
  },
];
